import { render, staticRenderFns } from "./DeletedKokuban.vue?vue&type=template&id=f3884d74&scoped=true&"
import script from "./DeletedKokuban.vue?vue&type=script&lang=js&"
export * from "./DeletedKokuban.vue?vue&type=script&lang=js&"
import style0 from "./DeletedKokuban.vue?vue&type=style&index=0&id=f3884d74&scoped=true&lang=css&"
import style1 from "./DeletedKokuban.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3884d74",
  null
  
)

export default component.exports